/* eslint-disable react/prop-types */
import EstimationDetailsLayout from "pages/NewOrder/layouts/EstimationLayout/EstimationDetailsLayout/EstimationDetailsLayout";
import EstimationRowLayout from "pages/NewOrder/layouts/EstimationLayout/EstimationRowLayout/EstimationRowLayout";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { retrieveContactCity, retrieveContactPaymentType } from "store/features/contact.store";
import { formatPrice } from "utility/helpers/general";

const EstimatedDetailsLine = ({ className, date, price }) => {
  const { t } = useTranslation();

  const {
    startingPrice,
    currency,
    discount: { discount, percentage },
    distance,
    vat,
    totalPrice,
  } = price;

  const city = useSelector(retrieveContactCity);
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  return (
    <EstimationDetailsLayout
      className={className}
      dateSection={date}
      priceSection={
        (discount > 0 || isCheckoutPaymentType) && (
          <EstimationRowLayout
            titleClassName="text-underlined"
            titleSection={t("newOrder.estimation.price")}
            contentSection={
              <Trans
                i18nKey="utils.pricing.exclVAT"
                tOptions={{ price: formatPrice(startingPrice, currency ?? "") }}
                components={{ span: <span /> }}
                defaults="<span>{{price}}</span> excl. VAT"
              />
            }
            data-cy="new-order-estimated-price"
          />
        )
      }
      discountSection={
        discount > 0 && (
          <EstimationRowLayout
            titleSection={t("newOrder.estimation.discount")}
            contentSection={formatPrice(discount, currency)}
            detailsSection={`(${formatPrice(percentage, "", "%")})`}
            data-cy="new-order-estimated-discount"
          />
        )
      }
      distanceSection={
        !!distance && (
          <EstimationRowLayout
            titleSection={t("newOrder.estimation.distance")}
            contentSection={t("newOrder.estimation.distanceValue", { context: city, distance: distance.toFixed(1) })}
            data-cy="new-order-estimated-distance"
          />
        )
      }
      vatSection={
        isCheckoutPaymentType && (
          <EstimationRowLayout
            titleClassName="text-underlined"
            titleSection={t("utils.pricing.vat")}
            contentSection={formatPrice(vat, currency ?? "")}
            data-cy="new-order-estimated-vat"
          />
        )
      }
      totalPriceSection={
        <EstimationRowLayout
          titleClassName="text-fw-bold text-underlined"
          titleSection={t("newOrder.estimation.total")}
          contentSection={
            <Trans
              i18nKey={isCheckoutPaymentType ? "utils.pricing.inclVAT" : "utils.pricing.exclVAT"}
              tOptions={{ price: formatPrice(totalPrice, currency ?? "") }}
              components={{ span: <span /> }}
              defaults={isCheckoutPaymentType ? "<span>{{price}}</span> inc. VAT" : "<span>{{price}}</span> excl. VAT"}
            />
          }
          data-cy="new-order-estimated-total"
        />
      }
      data-cy={date ? `estimation-line-${date}` : "estimation-line"}
    />
  );
};

export default EstimatedDetailsLine;
